import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AppConfiguration } from '../../../../core/models/app-configuration.model';
import { ContactRequest } from 'app/shared/model/contacts.model';

@Injectable({ providedIn: 'root' })
export class TwoStepVerificationSmsService {
  constructor(private readonly http: HttpClient, private readonly appConfig: AppConfiguration) { }

  getResourceUrl(): string {
    return this.appConfig.serverApiUrl + '/api/v1/twofactor/sms';
  }

  oldEnable2fa(): Observable<{ enabled: boolean }> {
    return this.http.post<{ enabled: boolean }>(this.getResourceUrl(), {});
  }

  get2FaStatus(): Observable<{ enabled: boolean }> {
    return this.http.get<{ enabled: boolean }>(this.getResourceUrl(), {});
  }

  enable2fa(authReqId: string, req: ContactRequest): Observable<{ enabled: boolean }> {
    const options = { headers: new HttpHeaders({ authPermission: authReqId }) };
    return this.http.put<{ enabled: boolean }>(this.getResourceUrl(), req, options);
  }

  disable2fa(authReqId: string, req: ContactRequest): Observable<{ enabled: boolean }> {
    const options = { headers: new HttpHeaders({ authPermission: authReqId }) };
    return this.http.post<{ enabled: boolean }>(this.getResourceUrl(), req, options);
  }
}
